import React from 'react';
import AddElement from './AddElement';

interface AddNotesProps {
  onClick: () => void;
}
const AddNotes: React.FC<AddNotesProps> = ({ onClick }) => (
  <AddElement label="Notes" onClick={onClick} />
);

export default AddNotes;
